"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bgPositionStateMachine = exports.stateMachineDataTypeMatch = void 0;
var data_types_consts_1 = require("./data-types-consts");
var data_types_utils_1 = require("./data-types-utils");
var PREDICATE_STATE_START = 'start';
var stateMachineDataTypeMatch = function (items, index, stateMachine) {
    var returnMatch = 0;
    var valueIndex = 0;
    var currKey = PREDICATE_STATE_START;
    if (!currKey || !stateMachine[valueIndex]) {
        return returnMatch;
    }
    var match;
    do {
        var newMatch = void 0;
        var currItem = items[index + valueIndex];
        if (currItem) {
            var possibleMatches = stateMachine[valueIndex][currKey];
            if (possibleMatches) {
                for (var i = 0; i < possibleMatches.length; i++) {
                    var stateMatch = possibleMatches[i];
                    if (stateMatch.predicate(currItem.value)) {
                        newMatch = stateMatch;
                        break;
                    }
                }
                if (newMatch) {
                    returnMatch++;
                    currKey = newMatch.nextKey;
                }
            }
        }
        if (!newMatch && match && match.mustContinue) {
            returnMatch--;
        }
        match = newMatch;
    } while (match && currKey && stateMachine[++valueIndex]);
    return returnMatch;
};
exports.stateMachineDataTypeMatch = stateMachineDataTypeMatch;
var bgPositionStateMachine = function (lengthPercentagePredicate) {
    var _a;
    var centerPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BG_POSITION_CENTER_KEYWORD);
    var horizontalPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BG_POSITION_HORIZONTAL_KEYWORDS_MAP);
    var verticalPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BG_POSITION_VERTICAL_KEYWORDS_MAP);
    var allEdgesPredicate = (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BG_POSITION_ALL_EDGES_KEYWORDS);
    /*
    syntax: [
      [ left | center | right | top | bottom | <length-percentage> ] |
      [ left | center | right | <length-percentage> ] [ top | center | bottom | <length-percentage> ] |
      [ center | [ left | right ] <length-percentage>? ]
        && [ center | [ top | bottom] <length-percentage>? ]
    ]
  */
    return [
        (_a = {},
            _a[PREDICATE_STATE_START] = [
                // <length-percentage>
                { predicate: lengthPercentagePredicate, nextKey: '<length-percentage>' },
                // center
                { predicate: centerPredicate, nextKey: 'center' },
                // left | right
                { predicate: horizontalPredicate, nextKey: 'left | right' },
                // top | bottom
                { predicate: verticalPredicate, nextKey: 'top | bottom' },
            ],
            _a),
        {
            '<length-percentage>': [
                // <length-percentage> <length-percentage> $
                { predicate: lengthPercentagePredicate },
                // <length-percentage> center $
                { predicate: centerPredicate },
                // <length-percentage> [ top | bottom ] $
                { predicate: verticalPredicate },
            ],
            center: [
                // center <length-percentage> $
                { predicate: lengthPercentagePredicate },
                // center center $
                { predicate: centerPredicate },
                // center [ left | right | top | bottom ]
                { predicate: allEdgesPredicate, nextKey: '3-value' },
            ],
            'left | right': [
                // [ left | right ] <length-percentage>
                { predicate: lengthPercentagePredicate, nextKey: '[ left | right ] <length-percentage>' },
                // [ left | right ] center $
                { predicate: centerPredicate },
                // [ left |right ] [ top | bottom ]
                { predicate: verticalPredicate, nextKey: '3-value' },
            ],
            'top | bottom': [
                // [ top | bottom ] <length-percentage>
                {
                    predicate: lengthPercentagePredicate,
                    nextKey: '[ top | bottom ] <length-percentage>',
                    mustContinue: true,
                },
                // [ top | bottom ] center $
                { predicate: centerPredicate },
                // [ top | bottom ] [ left |right ]
                { predicate: horizontalPredicate, nextKey: '3-value' },
            ],
        },
        {
            '3-value': [
                // center [ left | right | top | bottom ] <length-percentage> $
                { predicate: lengthPercentagePredicate },
            ],
            '[ left | right ] <length-percentage>': [
                // [ left | right ] <length-percentage> center $
                { predicate: centerPredicate },
                // [ left | right ] <length-percentage> [ top | bottom ]
                { predicate: verticalPredicate, nextKey: '4-value' },
            ],
            '[ top | bottom ] <length-percentage>': [
                // [ top | bottom ] <length-percentage> center $
                { predicate: centerPredicate },
                // [ top | bottom ] <length-percentage> [ left | right ]
                { predicate: horizontalPredicate, nextKey: '4-value' },
            ],
        },
        {
            '4-value': [
                // [ left | right ] <length-percentage> [ top | bottom ] <length-percentage> $
                // [ top | bottom ] <length-percentage> [ left | right ] <length-percentage> $
                { predicate: lengthPercentagePredicate },
            ],
        },
    ];
};
exports.bgPositionStateMachine = bgPositionStateMachine;
//# sourceMappingURL=data-types-state-machines.js.map